export default "__VITE_ASSET__B9W4izIq__"